import React from 'react'
import {Line} from 'react-chartjs-2'
import type {MonthlyVolume} from './_requests'

interface Props {
  data: MonthlyVolume[]
  periodLabel: string
}

export const VolumeTrendChart: React.FC<Props> = ({data, periodLabel}) => {
  const chartData = {
    labels: data.map((d) => d.label),
    datasets: [
      {
        data: data.map((d) => d.minutes),
        borderColor: '#a3a242',
        backgroundColor: 'rgba(163, 162, 66, 0.08)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#a3a242',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
      },
    ],
  }

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {display: false},
      tooltip: {
        callbacks: {
          label: (ctx: any) => `${ctx.parsed.y.toLocaleString()} mins`,
        },
      },
    },
    scales: {
      x: {
        grid: {display: false},
        ticks: {font: {family: 'Manrope', size: 12}, color: '#565d6d'},
      },
      y: {
        grid: {color: '#f3f4f6', drawBorder: false},
        ticks: {
          font: {family: 'Manrope', size: 11},
          color: '#565d6d',
          callback: (v: number) => v.toLocaleString(),
        },
      },
    },
  }

  return (
    <div className='cp-chart-card'>
      <h3 className='cp-chart-card__title'>Interpretation (Mins) Served Volume Trend</h3>
      <p className='cp-chart-card__subtitle'>{periodLabel}</p>
      <div style={{height: 250}}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  )
}
